import * as React from "react";
import { forwardRef } from "react";
const SvgChevronBaseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 6, viewBox: "0 0 8 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.94 0.529785L4 3.58312L7.06 0.529785L8 1.46979L4 5.46979L0 1.46979L0.94 0.529785Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgChevronBaseIcon);
export { ForwardRef as ReactComponent };
